import React, { Component } from 'react';
import { Paper, Button, InputLabel, FormControl } from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import Datetime from 'react-datetime';
import GridItem from '../Grid/GridItem.jsx';
import GridContainer from '../Grid/GridContainer.jsx';
import { CodeSharp } from '@material-ui/icons';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
class DateTimePanel extends Component {
    constructor() {
        super();
        this.state = {
            dateTimeValue: ''
        };
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };


    render() {
        const { userData } = this.props;

        return (
            <div className="main-panel mb-4">
                <div>
                    <h4 className="mb-2">
                        {this.props.fromDate && this.props.fromDate}
                        {this.props.toDate && this.props.toDate}
                        {!this.props.fromDate && !this.props.toDate && !this.props.dob &&
                            <FormattedMessage
                                id="datetime.heading"
                                defaultMessage="Date and Time"
                            />}
                    </h4>
                </div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className="cpn-pag-form">
                        <form className="form-new">
                            <FormControl
                                fullWidth
                                className="login-form-textfield"
                            >
                                <Datetime

                                    open={this.props.open}
                                    isValidDate={this.props.isValidDate}
                                    timeFormat={this.props.timeFormat}
                                    viewDate={moment().format('MM-DD-YYYY')}
                                    format={"MMM-dd-yyyy"}
                                    color="primary"
                                    inputProps={{
                                        placeholder: this.props.intl.formatMessage(
                                            {
                                                id: 'Select Date'

                                            }

                                        )

                                    }}
                                    defaultValue={this.props.defaultValue}
                                    value={this.props.value}
                                    onChange={this.props.onChange}

                                />
                            </FormControl>
                        </form>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}
export default withTheme()(withUser(injectIntl(DateTimePanel)));



// WEBPACK FOOTER //
// ./src/components/Booking/DateTimePanel.jsx